"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainScanExplorers = exports.ScanExplorers = void 0;
var Enums_1 = require("./Enums/");
var ScanExplorer = /** @class */ (function () {
    function ScanExplorer(baseUrl, options) {
        if (options === void 0) { options = {}; }
        this.baseUrl = baseUrl;
        this.options = options;
        this.options = {
            txPath: "tx",
            tokenPath: "token",
            addressPath: "address",
        };
    }
    ScanExplorer.prototype.tx = function (hash) {
        return this.baseUrl + "/" + this.options.txPath + "/" + hash;
    };
    ScanExplorer.prototype.token = function (address) {
        return this.baseUrl + "/" + this.options.tokenPath + "/" + address;
    };
    ScanExplorer.prototype.address = function (address) {
        return this.baseUrl + "/" + this.options.addressPath + "/" + address;
    };
    return ScanExplorer;
}());
exports.ScanExplorers = {
    BscScan: new ScanExplorer("https://bscscan.com"),
    BscScanTestnet: new ScanExplorer("https://testnet.bscscan.com"),
    EtherScan: new ScanExplorer("https://etherscan.io"),
    HarmonyExplorer: new ScanExplorer("https://explorer.harmony.one", {
        tokenPath: "address",
    }),
    IotexScan: new ScanExplorer("https://iotexscan.io", { txPath: "action" }),
    PolygonScan: new ScanExplorer("https://polygonscan.com"),
    RinkebyScan: new ScanExplorer("https://rinkeby.etherscan.io/"),
    GoerliScan: new ScanExplorer("https://goerli.etherscan.io/"),
    FtmScan: new ScanExplorer("https://ftmscan.com"),
    BttcScan: new ScanExplorer("https://bttcscan.com/"),
    OntologyTestnetExplorer: new ScanExplorer("https://explorer.ont.io/testnet/"),
    OntologyExplorer: new ScanExplorer("https://explorer.ont.io/"),
    AvalancheST: new ScanExplorer("https://snowtrace.io/"),
    TronScan: new ScanExplorer("https://tronscan.org/#/", {
        txPath: "transaction",
        tokenPath: "token20",
    }),
};
exports.BlockchainScanExplorers = (_a = {},
    _a[Enums_1.Blockchains.Binance] = exports.ScanExplorers["BscScan"],
    _a[Enums_1.Blockchains.BinanceTestnet] = exports.ScanExplorers["BscScanTestnet"],
    _a[Enums_1.Blockchains.Ethereum] = exports.ScanExplorers["EtherScan"],
    _a[Enums_1.Blockchains.Harmony] = exports.ScanExplorers["HarmonyExplorer"],
    _a[Enums_1.Blockchains.Iotex] = exports.ScanExplorers["IotexScab"],
    _a[Enums_1.Blockchains.Polygon] = exports.ScanExplorers["PolygonScan"],
    _a[Enums_1.Blockchains.EthereumGoerli] = exports.ScanExplorers["GoerliScan"],
    _a[Enums_1.Blockchains.FTM] = exports.ScanExplorers["FtmScan"],
    _a[Enums_1.Blockchains.EthereumRinkeby] = exports.ScanExplorers["RinkebyScan"],
    _a[Enums_1.Blockchains.BTTC] = exports.ScanExplorers["BttcScan"],
    _a[Enums_1.Blockchains.OntologyTestnet] = exports.ScanExplorers["OntologyTestnetExplorer"],
    _a[Enums_1.Blockchains.Ontology] = exports.ScanExplorers["OntologyExplorer"],
    _a[Enums_1.Blockchains.Avalanche] = exports.ScanExplorers["AvalancheST"],
    _a[Enums_1.Blockchains.Tron] = exports.ScanExplorers["TronScan"],
    _a);
